import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFiteComponent } from './simple-icons-fite.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFiteComponent ],
    exports:      [ SimpleIconsFiteComponent ],
    bootstrap:    []
})
export class SimpleIconsFiteModule {}
